import React, { useRef, useState } from "react";
import { Tag, Typography, Input, Button, Tabs } from "antd";
import { SearchOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
//import './Reports.scss';
import PrimaryNav from "../../shared/PrimaryNav";
import PageHeader from "../../shared/PageHeader";
import sampleCredit from "./sampleCredit.json";
import AgTableClient from "../../shared/AgTable/AgTableClient";


const columnDefs = [
  {
    headerName: "Account Name",
    valueGetter: (p) => p.data["ACC.ACCOUNT NAME"],
    filter: "agTextColumnFilter",
    enableRowGroup: true,
    // formatType: "ENTITY_WITH_LOGO"
    formatType: "ENTITY",
    field: "ACC.ACCOUNT NAME",
  },
  {
    headerName: "Approval Code",
    valueGetter: (p) => p.data["FIN.APPROVAL CODE"],
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "Posting Date",
    valueGetter: (p) => p.data["FIN.POSTING DATE"],
    filter: "agDateColumnFilter",
    enableRowGroup: true,
    // formatType: "DATE",
  },
  {
    headerName: "Transaction Date",
    valueGetter: (p) => p.data["FIN.TRANSACTION DATE"],
    filter: "agDateColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "Merchant Name",
    valueGetter: (p) => p.data["MCH.MERCHANT NAME"],
    filter: "agTextColumnFilter",
    enableRowGroup: true,
    formatType: "ENTITY_WITH_LOGO",
    field: "MCH.MERCHANT NAME",
  },
  {
    headerName: "Transaction Description",
    valueGetter: (p) => p.data["FIN.TRANSACTION DESCRIPTION"],
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "Original Currency Symbol",
    valueGetter: (p) => p.data["FIN.ORIGINAL ISO CURRENCY CODE SYMBOL"],
    filter: "agSetColumnFilter",
    filterParams: {
      values: ["INR", "EUR"],
    },
    enableRowGroup: true,
  },
  {
    headerName: "POSTED CURRENCY SYMBOL",
    valueGetter: (p) => p.data["FIN.POSTED ISO CURRENCY CODE SYMBOL"],
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "DEBIT CREDIT CODE",
    valueGetter: (p) => p.data["FIN.DEBIT CREDIT CODE"],
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "ORIGINAL CURRENCY CODE",
    valueGetter: (p) => p.data["FIN.ORIGINAL CURRENCY CODE"],
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "ORIGINAL CURRENCY AMOUNT",
    valueGetter: (p) => p.data["FIN.ORIGINAL CURRENCY AMOUNT"],
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    formatType: "AMOUNT",
    field: "FIN.ORIGINAL CURRENCY AMOUNT",
  },
  {
    headerName: "TRANSACTION AMOUNT",
    valueGetter: (p) => p.data["FIN.TRANSACTION AMOUNT"],
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    formatType: "AMOUNT",
    field: "FIN.TRANSACTION AMOUNT",
  },
  {
    headerName: "AIR FARE AMOUNT",
    valueGetter: (p) => p.data["PT.AIR.FARE AMOUNT"],
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    formatType: "AMOUNT",
    field: "PT.AIR.FARE AMOUNT",
  },
  {
    headerName: "TOTAL TAXES AMOUNT",
    valueGetter: (p) => p.data["PT.TOTAL TAXES AMOUNT"],
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    formatType: "AMOUNT",
    field: "PT.TOTAL TAXES AMOUNT",
  },
  {
    headerName: "TRANSPORT ADDENDUM",
    valueGetter: (p) => p.data["FIN.PASSENGER TRANSPORT ADDENDUM PRESENT"],
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "CARRIER CODE",
    valueGetter: (p) => p.data["PT.AIR.CARRIER CODE"],
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "FLIGHT NUMBER",
    valueGetter: (p) => p.data["PT.AIR.FLIGHT NUMBER"],
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "SERVICE CLASS",
    valueGetter: (p) => p.data["PT.AIR.SERVICE CLASS"],
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "CITY OF DESTINATION",
    valueGetter: (p) => p.data["PT.AIR.CITY OF DESTINATION"],
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "CITY OF ORIGIN",
    valueGetter: (p) => p.data["PT.AIR.CITY OF ORIGIN"],
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "DEPARTURE TIME",
    valueGetter: (p) => p.data["PT.AIR.DEPARTURE TIME"],
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "ARRIVAL TIME",
    valueGetter: (p) => p.data["PT.AIR.ARRIVAL TIME"],
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "TICKET TYPE",
    valueGetter: (p) => p.data["PT.TICKET TYPE"],
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "TICKET NUMBER",
    valueGetter: (p) => p.data["PT.TICKET NUMBER"],
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "TRAVEL DATE",
    valueGetter: (p) => p.data["PT.AIR.TRAVEL DATE"],
    filter: "agDateColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "ISSUE DATE",
    valueGetter: (p) => p.data["PT.ISSUE DATE"],
    filter: "agDateColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "PASSENGER NAME",
    valueGetter: (p) => p.data["PT.PASSENGER NAME"],
    filter: "agTextColumnFilter",
    enableRowGroup: true,
    formatType: "PERSON",
    field: "PT.PASSENGER NAME",
  },
  {
    headerName: "AGENCY INVOICE NUMBER",
    valueGetter: (p) => p.data["PT.TRAVEL AGENCY INVOICE NUMBER"],
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "CFF DATA 03",
    valueGetter: (p) => p.data["PT.CFF.DATA 03"],
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "CFF DATA 04",
    valueGetter: (p) => p.data["PT.CFF.DATA 04"],
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "CFF DATA 05",
    valueGetter: (p) => p.data["PT.CFF.DATA 05"],
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "CFF DATA 06",
    valueGetter: (p) => p.data["PT.CFF.DATA 06"],
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "CFF DATA 07",
    valueGetter: (p) => p.data["PT.CFF.DATA 07"],
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "CFF DATA 08",
    valueGetter: (p) => p.data["PT.CFF.DATA 08"],
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "CFF DATA 09",
    valueGetter: (p) => p.data["PT.CFF.DATA 09"],
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "CFF DATA 10",
    valueGetter: (p) => p.data["PT.CFF.DATA 10"],
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "CFF DATA 11",
    valueGetter: (p) => p.data["PT.CFF.DATA 11"],
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "CFF DATA 12",
    valueGetter: (p) => p.data["PT.CFF.DATA 12"],
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "DOMESTIC SWITCH",
    valueGetter: (p) => p.data["PT.DOMESTIC SWITCH"],
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "AGENCY SEQ NO",
    valueGetter: (p) => p.data["TAF.TRAVEL AGENCY SEQUENCE NUMBER"],
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "AIR TAX AMOUNT",
    valueGetter: (p) => p.data["PT.AIR.TAX AMOUNT"],
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "AIR FEE AMOUNT",
    valueGetter: (p) => p.data["PT.AIR.FEE AMOUNT"],
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    formatType: "AMOUNT",
    field: "PT.AIR.FEE AMOUNT",
  },
  {
    headerName: "TAX DISCOUNT AMOUNT",
    valueGetter: (p) => p.data["PT.TAX.DISCOUNT AMOUNT"],
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    formatType: "AMOUNT",
    field: "PT.TAX.DISCOUNT AMOUNT",
  },
  {
    headerName: "TAX NET AMOUNT",
    valueGetter: (p) => p.data["PT.TAX.NET AMOUNT"],
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    formatType: "AMOUNT",
    field: "PT.TAX.NET AMOUNT",
  },
  {
    headerName: "TOTAL FARE AMOUNT",
    valueGetter: (p) => p.data["PT.TOTAL FARE AMOUNT"],
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    formatType: "AMOUNT",
    field: "PT.TOTAL FARE AMOUNT",
  },
  {
    headerName: "TAXABLE AMOUNT",
    valueGetter: (p) => p.data["PT.TAX.TAXABLE AMOUNT"],
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    formatType: "AMOUNT",
    field: "PT.TAX.TAXABLE AMOUNT",
  },
  {
    headerName: "EXPENSE DESCRIPTION",
    valueGetter: (p) => p.data["FIN.EXPENSE DESCRIPTION"],
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "ITEM DESCRIPTION",
    valueGetter: (p) => p.data["FLT.ITEM DESCRIPTION"],
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "ADJUSTMENT DESCRIPTION",
    valueGetter: (p) => p.data["FIN.ADJUSTMENT DESCRIPTION"],
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "TAF DESCRIPTION/TYPE",
    valueGetter: (p) => p.data["TAF.DESCRIPTION/TYPE"],
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "TAF FEE",
    valueGetter: (p) => p.data["TAF.FEE"],
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "TAF FEE SIGN",
    valueGetter: (p) => p.data["TAF.FEE SIGN"],
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "TAF RATE",
    valueGetter: (p) => p.data["TAF.RATE"],
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "PROCESSOR TXN ID",
    valueGetter: (p) => p.data["FIN.PROCESSOR TRANSACTION ID"],
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "EXCHANGE TICKET NO",
    valueGetter: (p) => p.data["PT.EXCHANGE TICKET NUMBER"],
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "EXCHANGE TICKET AMOUNT",
    valueGetter: (p) => p.data["PT.EXCHANGE TICKET AMOUNT"],
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
    formatType: "AMOUNT",
    field: "PT.EXCHANGE TICKET AMOUNT",
  },
  {
    headerName: "TRANSACTION REF NO",
    valueGetter: (p) => p.data["FIN.TRANSACTION REFERENCE NUMBER"],
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "MERCHANT CATEGORY CODE",
    valueGetter: (p) => p.data["MCH.MERCHANT CATEGORY CODE (MCC)"],
    filter: "agNumberColumnFilter",
    enableRowGroup: true,
  },
  {
    headerName: "MCC DESCRIPTION",
    valueGetter: (p) => p.data["MCH.MCC DESCRIPTION"],
    filter: "agTextColumnFilter",
    enableRowGroup: true,
  },
];

const rowData = sampleCredit;
console.log(rowData, "row");

function CreditData() {
  const ref = useRef(null);
  const [activeTab, setActiveTab] = useState("my data");

  const items = [
    {
      key: "1",
      label: "Recon A",
    },
    {
      key: "2",
      label: "Recon B",
    },
  ];

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <PageHeader title="Credit Card Statement" />
      {/* ag-Grid Table */}
      <div style={{ flex: 1, marginTop: "16px" }}>
        <AgTableClient
          columnDefs={columnDefs}
          rowData={rowData}
          ref={ref}
          groupPanel
        />
      </div>
    </div>
  );
}

export default CreditData;
